export function getSizeTypes(st) {
    var result = [];
//    console.log('getSizeTypes result=',result);
    return result;
}

export function getSizeEntries(type, st) {
//    console.log('getSizeEntries type=',type,' st=',st);
    var result = [];
//    console.log('getSizeEntries result=',result);
    return result;
}
